import { LoadListFilters } from "@/models/api/barcodeSystem/loads/get";
import { LoadResource } from "@/models/api/barcodeSystem/loads/get";
import { CompanyResource } from "../../../../models/api/barcodeSystem/barcodeCompanies/get";

export function defaultSummaryFilters(): LoadListFilters {
  return {
    id: null,
    facilityCodes: null,
    loadName: null,
    billToCompanyIds: null,
    companyIds: null,
    importedDate: null,
    isLocked: null,
    isOpen: true,
    showZeroOrders: false
    } as LoadListFilters;
}

export function defaultLoad(): LoadResource {
  return {
    id: null,
    loadName: null,
    status: null,
    locked: null,
    isLocked: null,
    facilityCode: null,
    billToCompanyId: null,
    companyId: null,
    companyName: "",
    importedDate: null,
    } as LoadResource;
}


